// extracted by mini-css-extract-plugin
module.exports = {"rich-text":"RichText_rich-text__Xj3Dc","rich-text__content":"RichText_rich-text__content__d6pnz","hover":"RichText_hover__kFbJQ"};